import { useState, useEffect, useCallback } from 'react';
import { supabase, DailyQuestion, SubmitAnswerResult } from '../lib/supabase';

export function useDailyQuestion(userId: string | undefined, lang: string = 'fr') {
  const [data, setData] = useState<DailyQuestion | null>(null);
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState<SubmitAnswerResult | null>(null);

  const fetch = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    const { data: rpcData, error } = await supabase.rpc('get_daily_question', { p_lang: lang });
    if (error) {
      console.error('get_daily_question error:', error);
    } else {
      setData(rpcData as unknown as DailyQuestion);
    }
    setLoading(false);
  }, [userId, lang]);

  useEffect(() => { fetch(); }, [fetch]);

  const submitAnswer = useCallback(async (answerId: string) => {
    if (!data?.question) return null;
    const { data: rpcResult, error } = await supabase.rpc('submit_daily_answer', {
      p_question_id: data.question.id,
      p_answer_id: answerId,
    });
    if (error) {
      console.error('submit_daily_answer error:', error);
      return null;
    }
    const typed = rpcResult as unknown as SubmitAnswerResult;
    setResult(typed);
    // Refetch to get the answered state (with score_impact on answers)
    await fetch();
    return typed;
  }, [data?.question, fetch]);

  return {
    question: data?.question ?? null,
    answers: data?.answers ?? [],
    alreadyAnswered: data?.already_answered ?? false,
    selectedAnswerId: data?.selected_answer_id ?? null,
    allCompleted: data?.all_completed ?? false,
    loading,
    submitAnswer,
    result,
  };
}
